module.exports = __webpack_public_path__ + "c420ad5b5fd6819f1dbfaa93b569f149.svg";